import Combobox from "@/components/Combobox";
import { CountryFlag, CountryFlagWithLabel } from "@/components/CountryFlag";
import Icon from "@/components/Icon/Icon";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import type { SupportedCountry } from "@/constants/country";
import type { UseSelectCountryReturn } from "../-hooks/useSelectCountry";
import type { CountryOption } from "../-types";

export function SelectCountryPresenter({
  open,
  setOpen,
  searchText,
  setSearchText,
  countryOptions,
  selectedCountry,
  handleCountryChange,
  t,
}: UseSelectCountryReturn) {
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-44 justify-between"
        >
          <div className="flex items-center gap-2">
            {selectedCountry?.value && (
              <CountryFlag countryCode={selectedCountry.value} />
            )}
            <span>{selectedCountry?.label ?? t("placeholder")}</span>
          </div>
          <Icon
            iconName="ChevronDownIcon"
            className="ml-2 shrink-0 opacity-50"
          />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-60 p-0">
        <Combobox<CountryOption>
          type="single"
          options={countryOptions}
          value={selectedCountry?.value || ""}
          onValueChange={(value: string | null) =>
            handleCountryChange(
              value ? (value as keyof typeof SupportedCountry) : undefined,
            )
          }
          search={searchText}
          onSearchChange={setSearchText}
          searchPlaceholder={t("searchPlaceholder")}
          noResultsMessage={t("noResultsMessage")}
          showCheckbox={false}
          renderOption={({ option }: { option: CountryOption }) => (
            <CountryFlagWithLabel
              countryCode={option.value}
              label={option.label}
            />
          )}
        />
      </PopoverContent>
    </Popover>
  );
}
